<template>
  <div class="pages-auth-layout-wrapper">
    <a href="/" class="pages-auth-layout-logo"
      ><img
        src="data:image/png;base64,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"
        alt="91xft.cn"
    /></a>
    <div class="pages-auth-layout-left">
      <div class="pages-auth-layout-slogan">
        <h1>领先的支付解决方案提供商</h1>
        <div class="pages-auth-layout-small">
          <span>追赶</span><i class="pages-auth-layout-triangle"></i
          ><span>超越</span><i class="pages-auth-layout-triangle"></i
          ><span>引领</span>
        </div>
      </div>
    </div>
    <div class="pages-auth-layout-right">
      <div class="pages-auth-layout-content">
        <div class="pages-auth-layout-main">
          <h2 class="pages-auth-login-index-title">欢迎登录</h2>
          <div class="ant-tabs ant-tabs-top ant-tabs-large ant-tabs-line">
            <div
              role="tablist"
              tabindex="0"
              class="ant-tabs-bar ant-tabs-top-bar ant-tabs-large-bar"
            >
              <div class="ant-tabs-nav-container">
                <span
                  unselectable="unselectable"
                  class="ant-tabs-tab-prev ant-tabs-tab-btn-disabled"
                  ><span class="ant-tabs-tab-prev-icon"
                    ><i
                      aria-label="icon: left"
                      class="anticon anticon-left ant-tabs-tab-prev-icon-target"
                      ><svg
                        viewBox="64 64 896 896"
                        data-icon="left"
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        aria-hidden="true"
                        focusable="false"
                        class=""
                      >
                        <path
                          d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                        ></path></svg></i></span></span
                ><span
                  unselectable="unselectable"
                  class="ant-tabs-tab-next ant-tabs-tab-btn-disabled"
                  ><span class="ant-tabs-tab-next-icon"
                    ><i
                      aria-label="icon: right"
                      class="anticon anticon-right ant-tabs-tab-next-icon-target"
                      ><svg
                        viewBox="64 64 896 896"
                        data-icon="right"
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        aria-hidden="true"
                        focusable="false"
                        class=""
                      >
                        <path
                          d="M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z"
                        ></path></svg></i></span
                ></span>
                <div class="ant-tabs-nav-wrap">
                  <div class="ant-tabs-nav-scroll">
                    <div class="ant-tabs-nav ant-tabs-nav-animated">
                      <div>
                        <div
                          role="tab"
                          aria-disabled="false"
                          aria-selected="true"
                          class="ant-tabs-tab-active ant-tabs-tab"
                        >
                          帐号登录
                        </div>
                      </div>
                      <div
                        class="ant-tabs-ink-bar ant-tabs-ink-bar-animated"
                        style="display: block; transform: translate3d(0px, 0px, 0px); width: 96px;"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              tabindex="0"
              role="presentation"
              style="width: 0px; height: 0px; overflow: hidden; position: absolute;"
            ></div>
            <div
              class="ant-tabs-content ant-tabs-content-animated ant-tabs-top-content"
              style="margin-left: 0%;"
            >
              <div
                role="tabpanel"
                aria-hidden="false"
                class="ant-tabs-tabpane ant-tabs-tabpane-active"
              >
                <div
                  tabindex="0"
                  role="presentation"
                  style="width: 0px; height: 0px; overflow: hidden; position: absolute;"
                ></div>
                <div class="ant-form ant-form-vertical">
                  <input type="password" hidden autocomplete="new-password" />
                  <div class="ant-row ant-form-item">
                    <div class="ant-col ant-form-item-label">
                      <label title="帐号" class="ant-form-item-required"
                        >帐号</label
                      >
                    </div>
                    <div class="ant-col ant-form-item-control-wrapper">
                      <div class="ant-form-item-control">
                        <span class="ant-form-item-children"
                          ><input
                            placeholder="请输入帐号"
                            type="text"
                            v-model="formInline.username"
                            class="ant-input ant-input-lg"/></span
                        ><!---->
                      </div>
                    </div>
                  </div>
                  <div class="ant-row ant-form-item">
                    <div class="ant-col ant-form-item-label">
                      <label title="密码" class="ant-form-item-required"
                        >密码</label
                      >
                    </div>
                    <div class="ant-col ant-form-item-control-wrapper">
                      <div class="ant-form-item-control">
                        <span class="ant-form-item-children"
                          ><span
                            class="ant-input-affix-wrapper ant-input-affix-wrapper-lg"
                            ><input
                              placeholder="请输入密码"
                              type="password"
                              v-model="formInline.password"
                              class="ant-input ant-input-lg"/><span
                              class="ant-input-suffix"
                            ></span></span></span
                        ><!---->
                      </div>
                    </div>
                  </div>
                  <div class="ant-row ant-form-item">
                    <div class="ant-col ant-form-item-control-wrapper">
                      <div class="ant-form-item-control">
                        <span class="ant-form-item-children"
                          ><button
                            type="submit"
                            @click="handleSubmit"
                            class="ant-btn ant-btn-primary ant-btn-lg"
                            style="width: 240px; border-radius: 4px;"
                          >
                            <span>登 录</span>
                          </button></span
                        ><!---->
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  tabindex="0"
                  role="presentation"
                  style="width: 0px; height: 0px; overflow: hidden; position: absolute;"
                ></div>
              </div>
            </div>
            <div
              tabindex="0"
              role="presentation"
              style="width: 0px; height: 0px; overflow: hidden; position: absolute;"
            ></div>
          </div>
        </div>
      </div>
      <img
        src="../assets/img/top-right-background.svg"
        alt=""
        class="top-right-background"
      /><img
        src="../assets/img/bottom-right-background.svg"
        alt=""
        class="bottom-right-background"
      />
    </div>
  </div>
</template>

<script>
import { login } from "@/api/index";
import { setToken, DAFAULT_HOME_URL } from "@/utils/util";
export default {
  name: "AccountApp",
  data() {
    return {
      formInline: {
        username: "",
        password: ""
      },
      psd: true,
      loading: false
    };
  },
  mounted() {
    document.addEventListener("keypress", e => {
      if (e.code === "Enter") {
        this.handleSubmit();
      }
    });
  },
  methods: {
    handleSubmit() {
      if (this.loading) return;
      const { username, password } = this.formInline;
      if (password && username) {
        this.loading = true;
        login(this.formInline)
          .then(({ token }) => {
            setToken(token);
            const { redirect } = this.$route.query;
            location.replace(redirect || DAFAULT_HOME_URL, true);
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
    changePassword() {
      this.psd = !this.psd;
    }
  }
};
</script>
